// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-page {
  min-height: 100vh;
  background: var(--bg);
  padding: 40px 20px 72px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
}

.rc-center {
  justify-content: center;
  text-align: center;
  color: var(--muted);
  gap: 14px;
}

.rc-vazio-titulo {
  font-family: var(--font-display);
  font-size: 1.3rem;
  color: var(--text);
}

.rc-vazio-codigo {
  font-size: 0.85rem;
  color: var(--muted2);
}

.rc-spin {
  animation: rc-rodar 1s linear infinite;
  color: var(--brand);
}

@keyframes rc-rodar {
  to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
  .rc-spin { animation: none; }
}

/* A folha é o que vai para o papel */
.rc-folha {
  width: 100%;
  max-width: 760px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 38px 40px 30px;
  box-shadow: var(--shadow);
}

.rc-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border);
}

.rc-logo {
  height: 46px;
  width: auto;
}

.rc-head-meta {
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.rc-head-tipo {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: var(--muted);
}

.rc-codigo {
  font-family: var(--font-display);
  font-size: 1.12rem;
  letter-spacing: 1px;
  color: var(--brand);
}

.rc-titulo {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text);
  margin-top: 24px;
  line-height: 1.25;
}

.rc-categoria {
  color: var(--muted);
  font-size: 0.9rem;
  margin-top: 4px;
}

.rc-selo-chegada {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin-top: 20px;
  padding: 13px 16px;
  border-radius: var(--radius);
  background: var(--brand-50);
  color: var(--brand-800);
  font-size: 0.88rem;
  line-height: 1.5;
}

.rc-selo-chegada > svg {
  flex: none;
  margin-top: 2px;
}

.rc-bloco {
  margin-top: 24px;
  border-top: 1px solid var(--border);
}

.rc-linha {
  display: flex;
  gap: 18px;
  padding: 11px 0;
  border-bottom: 1px solid var(--border);
  font-size: 0.92rem;
}

.rc-linha dt {
  flex: 0 0 180px;
  color: var(--muted);
}

.rc-linha dd {
  flex: 1 1;
  color: var(--text);
  font-weight: 600;
}

.rc-prof,
.rc-local {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
}

.rc-verificado {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  background: var(--brand-100);
  color: var(--brand-800);
  font-size: 0.66rem;
  font-weight: 700;
}

.rc-descricao {
  margin-top: 24px;
}

.rc-descricao-rotulo {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: var(--muted);
  margin-bottom: 7px;
}

.rc-descricao p {
  color: var(--text-soft);
  font-size: 0.92rem;
  line-height: 1.65;
}

.rc-rodape {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 28px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  color: var(--muted);
  font-size: 0.78rem;
  line-height: 1.55;
}

.rc-rodape > svg {
  flex: none;
  margin-top: 2px;
}

.rc-acoes {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 560px) {
  .rc-folha { padding: 26px 20px 22px; }
  .rc-linha { flex-direction: column; gap: 3px; }
  .rc-linha dt { flex: none; }
  .rc-head { flex-direction: column; align-items: flex-start; }
  .rc-head-meta { text-align: left; }
}

/* Impressão: sai só a folha, sem sombra, fundo ou botões */
@media print {
  .rc-page {
    background: #fff;
    padding: 0;
    min-height: auto;
  }
  .rc-folha {
    max-width: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }
  .rc-acoes { display: none; }
  .rc-selo-chegada {
    border: 1px solid var(--brand-100);
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Receipt.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW,eAAe,EAAE;AAC9B;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY,uBAAuB,EAAE;EACrC,YAAY,sBAAsB,EAAE,QAAQ,EAAE;EAC9C,eAAe,UAAU,EAAE;EAC3B,WAAW,sBAAsB,EAAE,uBAAuB,EAAE;EAC5D,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA,2DAA2D;AAC3D;EACE;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;EACA,YAAY,aAAa,EAAE;EAC3B;IACE,kCAAkC;IAClC,yBAAyB;IACzB,iCAAiC;EACnC;AACF","sourcesContent":[".rc-page {\n  min-height: 100vh;\n  background: var(--bg);\n  padding: 40px 20px 72px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 22px;\n}\n\n.rc-center {\n  justify-content: center;\n  text-align: center;\n  color: var(--muted);\n  gap: 14px;\n}\n\n.rc-vazio-titulo {\n  font-family: var(--font-display);\n  font-size: 1.3rem;\n  color: var(--text);\n}\n\n.rc-vazio-codigo {\n  font-size: 0.85rem;\n  color: var(--muted2);\n}\n\n.rc-spin {\n  animation: rc-rodar 1s linear infinite;\n  color: var(--brand);\n}\n\n@keyframes rc-rodar {\n  to { transform: rotate(360deg); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rc-spin { animation: none; }\n}\n\n/* A folha é o que vai para o papel */\n.rc-folha {\n  width: 100%;\n  max-width: 760px;\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 38px 40px 30px;\n  box-shadow: var(--shadow);\n}\n\n.rc-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.rc-logo {\n  height: 46px;\n  width: auto;\n}\n\n.rc-head-meta {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.rc-head-tipo {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: var(--muted);\n}\n\n.rc-codigo {\n  font-family: var(--font-display);\n  font-size: 1.12rem;\n  letter-spacing: 1px;\n  color: var(--brand);\n}\n\n.rc-titulo {\n  font-family: var(--font-display);\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--text);\n  margin-top: 24px;\n  line-height: 1.25;\n}\n\n.rc-categoria {\n  color: var(--muted);\n  font-size: 0.9rem;\n  margin-top: 4px;\n}\n\n.rc-selo-chegada {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  margin-top: 20px;\n  padding: 13px 16px;\n  border-radius: var(--radius);\n  background: var(--brand-50);\n  color: var(--brand-800);\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.rc-selo-chegada > svg {\n  flex: none;\n  margin-top: 2px;\n}\n\n.rc-bloco {\n  margin-top: 24px;\n  border-top: 1px solid var(--border);\n}\n\n.rc-linha {\n  display: flex;\n  gap: 18px;\n  padding: 11px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.92rem;\n}\n\n.rc-linha dt {\n  flex: 0 0 180px;\n  color: var(--muted);\n}\n\n.rc-linha dd {\n  flex: 1;\n  color: var(--text);\n  font-weight: 600;\n}\n\n.rc-prof,\n.rc-local {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n\n.rc-verificado {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px 8px;\n  border-radius: var(--radius-pill);\n  background: var(--brand-100);\n  color: var(--brand-800);\n  font-size: 0.66rem;\n  font-weight: 700;\n}\n\n.rc-descricao {\n  margin-top: 24px;\n}\n\n.rc-descricao-rotulo {\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 1.2px;\n  text-transform: uppercase;\n  color: var(--muted);\n  margin-bottom: 7px;\n}\n\n.rc-descricao p {\n  color: var(--text-soft);\n  font-size: 0.92rem;\n  line-height: 1.65;\n}\n\n.rc-rodape {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 28px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n  color: var(--muted);\n  font-size: 0.78rem;\n  line-height: 1.55;\n}\n\n.rc-rodape > svg {\n  flex: none;\n  margin-top: 2px;\n}\n\n.rc-acoes {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n@media (max-width: 560px) {\n  .rc-folha { padding: 26px 20px 22px; }\n  .rc-linha { flex-direction: column; gap: 3px; }\n  .rc-linha dt { flex: none; }\n  .rc-head { flex-direction: column; align-items: flex-start; }\n  .rc-head-meta { text-align: left; }\n}\n\n/* Impressão: sai só a folha, sem sombra, fundo ou botões */\n@media print {\n  .rc-page {\n    background: #fff;\n    padding: 0;\n    min-height: auto;\n  }\n  .rc-folha {\n    max-width: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n    padding: 0;\n  }\n  .rc-acoes { display: none; }\n  .rc-selo-chegada {\n    border: 1px solid var(--brand-100);\n    print-color-adjust: exact;\n    -webkit-print-color-adjust: exact;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
